import getBrandingColours from "@/utils/getBrandColor";
import { sootchyTheme } from "./useSootchyTheme";

export const setBrandColors = ({
  brandColor,
}: {
  brandColor?: string | null | undefined;
}) => {
  const brandTheme = getBrandingColours({ lightVal: brandColor });

  sootchyTheme(brandTheme);
};
